import { useEffect } from "react";
import useAxiosPrivate from "./useAxiosPrivate";
import { useDispatch } from "react-redux";
import { getZoneListUpdate } from "../slice/appSlice";


const useZoneListUpdate = () => {
  const Axios = useAxiosPrivate();
  const dispatch = useDispatch();
  const getAllZoneList = async (state_id) => {
    const param ={
        state_id:state_id
    }
    const response = await Axios.post("/all_zone_list", param);
    const data = await response.data;
    dispatch(getZoneListUpdate(data.body));
    
  };
  return getAllZoneList;
};

export default useZoneListUpdate;